export default function (question) {
  if (question.questionText) return question.questionText.slice(0, 50);

  return question.questionType;
}
